export default __webpack_public_path__ + "static/1779-381bb0f49494d680373b34bd243c116a.gif";